const STORAGE_KEYS = {
  // 用户信息
  USER_INFO: 'tga-user-info',
  // 用户token
  USER_TOKEN: 'tga-user-token',
  // 用户语音状态
  USER_TALK_MIC_STATUS: 'tga-talk-mic',
  // 用户话筒状态
  USER_TALK_SPEAKER_STATUS: 'tga-talk-speaker',
  // 应用信息
  APP_CONFIG: 'tga-app-config'
}

export default STORAGE_KEYS
